export class SystemTablesOverviewViewModel {
  public settingsDict: { [key: string]: any[] } = {};
}
